module.exports = __webpack_public_path__ + "public/images/prizes/prize-1.97b7b467fd5f7084bd15102f9ccd4e82.jpg";